import React from "react";
import { connect } from "react-redux";

import { getData } from "Source/globalFunction";

import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        files: store.files
    };
})

class Task extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchIsLoading: false,
            searched: []
        }
    }

    render() {
        const { dispatch, projectId, files } = this.props;

        const searchTask = value => {
            const url = "api/task";
            const params = {
                projectId: projectId
            }

            this.setState({...this.state, searchIsLoading: true});

            getData(url, {params}, response => {
                if(response) {
                    this.setState({
                        ...this.state, 
                        searchIsLoading: false, 
                        searched: response.data.result.map(t => {
                            return {
                                value: t.id, 
                                label: t.task
                            }
                        })
                    })
                }
            })
        }

        const handleOpenSelect = () => {
            searchTask();
        }

        const handleSearch = (value) => {
            searchTask(value);
        }

        const handleSelect = (value) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {task: value} });
        }

        const handleClear = () => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {task: {}} });
        }
        return (
            <div class="optionRow">
                <span>Task</span>
                <div class="optionChoices searchIcon">
                    <Select 
                        showSelectedInOptions={false}
                        isSearchable={true}
                        isLoading={this.state.searchIsLoading}
                        classes={{options: "filesFilterOptions"}}
                        selected={files.filters.options.task}
                        placeholder="Search"
                        options={this.state.searched}
                        onOpen={handleOpenSelect}
                        onSearch={handleSearch}
                        onChange={handleSelect}
                        onClearSelected={handleClear}
                        isClose={files.filters.isCleared}
                    />
                </div>
            </div>
        );
    }
}

export default Task;